export default "/_next/static/images/team-life-bg-8a67a5ba7c38e842bc3641d4e2a4995b.png";